
export const HOST_URI = process.env.REACT_APP_API_HOST;
export const NOTIFICATION_WS_URL = process.env.REACT_APP_WS_NOTIFICATIONS_URL;

export const SPORTS = [
    {key: "american-football", value: "American football"},
    {key: "baseball", value: "Baseball"},
    {key: "basketball", value: "Basketball"},
    {key: "hockey", value: "Hockey"},
    {key: "rugby", value: "Rugby"},
    {key: "soccer", value: "Soccer"},
    {key: "softball", value: "Softball"},
    {key: "volleyball", value: "Volleyball"},
]

export const SUPPORTED_STRIPE_COUNTRIES = [
    // 🌍 North America
    {label: "United States", value: "US"},
    {label: "Canada", value: "CA"},
    {label: "Mexico", value: "MX"},

    // 🌎 Latin America
    {label: "Brazil", value: "BR"},
    {label: "Chile", value: "CL"},
    {label: "Colombia", value: "CO"},

    // 🌍 Europe
    {label: "Austria", value: "AT"},
    {label: "Belgium", value: "BE"},
    {label: "Bulgaria", value: "BG"},
    {label: "Croatia", value: "HR"},
    {label: "Cyprus", value: "CY"},
    {label: "Czech Republic", value: "CZ"},
    {label: "Denmark", value: "DK"},
    {label: "Estonia", value: "EE"},
    {label: "Finland", value: "FI"},
    {label: "France", value: "FR"},
    {label: "Germany", value: "DE"},
    {label: "Greece", value: "GR"},
    {label: "Hungary", value: "HU"},
    {label: "Ireland", value: "IE"},
    {label: "Italy", value: "IT"},
    {label: "Latvia", value: "LV"},
    {label: "Lithuania", value: "LT"},
    {label: "Luxembourg", value: "LU"},
    {label: "Malta", value: "MT"},
    {label: "Netherlands", value: "NL"},
    {label: "Norway", value: "NO"},
    {label: "Poland", value: "PL"},
    {label: "Portugal", value: "PT"},
    {label: "Romania", value: "RO"},
    {label: "Slovakia", value: "SK"},
    {label: "Slovenia", value: "SI"},
    {label: "Spain", value: "ES"},
    {label: "Sweden", value: "SE"},
    {label: "Switzerland", value: "CH"},
    {label: "United Kingdom", value: "GB"},

    // 🌏 Asia-Pacific
    {label: "Australia", value: "AU"},
    {label: "Hong Kong", value: "HK"},
    {label: "India", value: "IN"},
    {label: "Japan", value: "JP"},
    {label: "Malaysia", value: "MY"},
    {label: "New Zealand", value: "NZ"},
    {label: "Philippines", value: "PH"},
    {label: "Singapore", value: "SG"},
    {label: "South Korea", value: "KR"},
    {label: "Thailand", value: "TH"},

    // 🌍 Middle East & Africa
    {label: "Israel", value: "IL"},
    {label: "United Arab Emirates", value: "AE"},
    {label: "South Africa", value: "ZA"}
];

export const GOOGLE_PLACE_COUNTRY_OPTIONS = [
    {value: "Canada", label: "CA"},
    {value: "United States", label: "US"},
];

export const GOOGLE_PLACE_STATE_OPTIONS_BY_COUNTRY = {
    Canada: [
        {value: "Alberta", label: "AB — Alberta"},
        {value: "British Columbia", label: "BC — British Columbia"},
        {value: "Manitoba", label: "MB — Manitoba"},
        {value: "New Brunswick", label: "NB — New Brunswick"},
        {value: "Newfoundland and Labrador", label: "NL — Newfoundland and Labrador"},
        {value: "Nova Scotia", label: "NS — Nova Scotia"},
        {value: "Northwest Territories", label: "NT — Northwest Territories"},
        {value: "Nunavut", label: "NU — Nunavut"},
        {value: "Ontario", label: "ON — Ontario"},
        {value: "Prince Edward Island", label: "PE — Prince Edward Island"},
        {value: "Quebec", label: "QC — Quebec"},
        {value: "Saskatchewan", label: "SK — Saskatchewan"},
        {value: "Yukon", label: "YT — Yukon"},
    ],
    "United States": [
        {value: "Alabama", label: "AL — Alabama"},
        {value: "Alaska", label: "AK — Alaska"},
        {value: "Arizona", label: "AZ — Arizona"},
        {value: "Arkansas", label: "AR — Arkansas"},
        {value: "California", label: "CA — California"},
        {value: "Colorado", label: "CO — Colorado"},
        {value: "Connecticut", label: "CT — Connecticut"},
        {value: "Delaware", label: "DE — Delaware"},
        {value: "District of Columbia", label: "DC — District of Columbia"},
        {value: "Florida", label: "FL — Florida"},
        {value: "Georgia", label: "GA — Georgia"},
        {value: "Hawaii", label: "HI — Hawaii"},
        {value: "Idaho", label: "ID — Idaho"},
        {value: "Illinois", label: "IL — Illinois"},
        {value: "Indiana", label: "IN — Indiana"},
        {value: "Iowa", label: "IA — Iowa"},
        {value: "Kansas", label: "KS — Kansas"},
        {value: "Kentucky", label: "KY — Kentucky"},
        {value: "Louisiana", label: "LA — Louisiana"},
        {value: "Maine", label: "ME — Maine"},
        {value: "Maryland", label: "MD — Maryland"},
        {value: "Massachusetts", label: "MA — Massachusetts"},
        {value: "Michigan", label: "MI — Michigan"},
        {value: "Minnesota", label: "MN — Minnesota"},
        {value: "Mississippi", label: "MS — Mississippi"},
        {value: "Missouri", label: "MO — Missouri"},
        {value: "Montana", label: "MT — Montana"},
        {value: "Nebraska", label: "NE — Nebraska"},
        {value: "Nevada", label: "NV — Nevada"},
        {value: "New Hampshire", label: "NH — New Hampshire"},
        {value: "New Jersey", label: "NJ — New Jersey"},
        {value: "New Mexico", label: "NM — New Mexico"},
        {value: "New York", label: "NY — New York"},
        {value: "North Carolina", label: "NC — North Carolina"},
        {value: "North Dakota", label: "ND — North Dakota"},
        {value: "Ohio", label: "OH — Ohio"},
        {value: "Oklahoma", label: "OK — Oklahoma"},
        {value: "Oregon", label: "OR — Oregon"},
        {value: "Pennsylvania", label: "PA — Pennsylvania"},
        {value: "Rhode Island", label: "RI — Rhode Island"},
        {value: "South Carolina", label: "SC — South Carolina"},
        {value: "South Dakota", label: "SD — South Dakota"},
        {value: "Tennessee", label: "TN — Tennessee"},
        {value: "Texas", label: "TX — Texas"},
        {value: "Utah", label: "UT — Utah"},
        {value: "Vermont", label: "VT — Vermont"},
        {value: "Virginia", label: "VA — Virginia"},
        {value: "Washington", label: "WA — Washington"},
        {value: "West Virginia", label: "WV — West Virginia"},
        {value: "Wisconsin", label: "WI — Wisconsin"},
        {value: "Wyoming", label: "WY — Wyoming"},
    ],
};

export const CURRENCIES = [
    {label: "CAD", value: "CAD"},
    {label: "EUR", value: "EUR"},
    {label: "USD", value: "USD"},
];

export const NOTIFICATION_TYPES = [
    { value: "chat", label: "Chat" },
    { value: "event", label: "Event" },
    { value: "gamification", label: "Gamification" },
    { value: "notification", label: "Notification" },
    { value: "invite", label: "Invite" },
    { value: "payment", label: "Payment" },
    { value: "rate", label: "Ratings" },
    { value: "result", label: "Result" },
    { value: "team", label: "Team" },
    { value: "organization", label: "Organization" },
    { value: "link", label: "Link" },
];
